"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var IPC = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.chrome) === null || _a === void 0 ? void 0 : _a.webview;
var LEGACY_IPC = (_b = globalThis === null || globalThis === void 0 ? void 0 : globalThis.qt) === null || _b === void 0 ? void 0 : _b.webChannelTransport;
if (LEGACY_IPC)
    LEGACY_IPC.onmessage = function () { };
var events = new eventemitter3_1.default();
var ShellEventType;
(function (ShellEventType) {
    ShellEventType[ShellEventType["SIGNAL"] = 1] = "SIGNAL";
    ShellEventType[ShellEventType["INIT"] = 3] = "INIT";
    ShellEventType[ShellEventType["INVOKE_METHOD"] = 6] = "INVOKE_METHOD";
})(ShellEventType || (ShellEventType = {}));
var useShell = function () {
    var _a = (0, react_1.useState)({
        initialized: false,
        version: null,
        windowClosed: false,
        windowHidden: false,
    }), state = _a[0], setState = _a[1];
    var _b = (0, react_1.useState)({
        gpuVideoProcessing: false,
        nativeAssSubtitles: false,
    }), capabilities = _b[0], setCapabilities = _b[1];
    var on = function (name, listener) { return events.on(name, listener); };
    var off = function (name, listener) { return events.off(name, listener); };
    var send = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        try {
            IPC === null || IPC === void 0 ? void 0 : IPC.postMessage(JSON.stringify({
                id: 0,
                type: ShellEventType.INVOKE_METHOD,
                args: __spreadArray([method], args, true),
            }));
        }
        catch (e) {
            console.error('Shell', 'Failed to send event', e);
        }
    };
    (0, react_1.useEffect)(function () {
        var onWindowVisibilityChanged = function (data) {
            setState(function (state) { return (__assign(__assign({}, state), { windowClosed: data.visible === false && data.visibility === 0 })); });
        };
        var onWindowStateChanged = function (data) {
            setState(function (state) { return (__assign(__assign({}, state), { windowHidden: data.state === 9 })); });
        };
        on('win-visibility-changed', onWindowVisibilityChanged);
        on('win-state-changed', onWindowStateChanged);
        return function () {
            off('win-visibility-changed', onWindowVisibilityChanged);
            off('win-state-changed', onWindowStateChanged);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        var onMessage = function (message) {
            try {
                var event = JSON.parse(message.data);
                if (event.type === ShellEventType.INIT) {
                    var data = event.data;
                    var shellProperties_1 = Object.fromEntries(data.transport.properties
                        .filter(function (property) { return property.length >= 4 && property[1]; })
                        .map(function (_a) {
                        var name = _a[1], value = _a[3];
                        return [name, value];
                    }));
                    setState(function (state) {
                        var _a;
                        return (__assign(__assign({}, state), { initialized: true, version: (_a = shellProperties_1.shellVersion) !== null && _a !== void 0 ? _a : null }));
                    });
                    setCapabilities({
                        gpuVideoProcessing: shellProperties_1.gpuVideoProcessing === 'true',
                        nativeAssSubtitles: shellProperties_1.nativeAssSubtitles === 'true',
                    });
                }
                if (event.type === ShellEventType.SIGNAL) {
                    var args = event.args;
                    var methodName = args[0], methodArg = args[1];
                    events.emit(methodName, methodArg);
                }
            }
            catch (e) {
                console.error('Shell', 'Failed to handle event', e);
            }
        };
        IPC === null || IPC === void 0 ? void 0 : IPC.addEventListener('message', onMessage);
        IPC === null || IPC === void 0 ? void 0 : IPC.postMessage(JSON.stringify({
            id: 0,
            type: ShellEventType.INIT,
        }));
        return function () { return IPC === null || IPC === void 0 ? void 0 : IPC.removeEventListener('message', onMessage); };
    }, []);
    return {
        active: !!IPC,
        send: send,
        on: on,
        off: off,
        state: state,
        capabilities: capabilities,
    };
};
exports.default = useShell;
